module.exports = __webpack_public_path__ + "static/media/njmls-white.f24bfda4.png";